import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as vendorAPI from "./vendorApi";

export const getVendors = createAsyncThunk("vendors/getAll", async () => {
  const response = await vendorAPI.fetchVendors();
  return response.data;
});

export const addVendor = createAsyncThunk("vendors/add", async (vendor,{dispatch}) => {
  const response = await vendorAPI.createVendor(vendor);
  dispatch(getVendors())
  return response.data;
});

export const editVendor = createAsyncThunk(
  "vendors/edit",
  async ({ id, data },{dispatch}) => {
    const response = await vendorAPI.updateVendor(id, data);
    dispatch(getVendors())
    return response.data;
  }
);

export const removeVendor = createAsyncThunk("vendors/delete", async (id,{dispatch}) => {
  await vendorAPI.deleteVendor(id);
      dispatch(getVendors())
  return id;
});

const vendorSlice = createSlice({
  name: "vendors",
  initialState: {
    vendors: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Vendors
      .addCase(getVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload;
      })
      .addCase(getVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Add Vendor
      .addCase(addVendor.fulfilled, (state, action) => {
        // state.vendors.push(action.payload);
      })

      // Edit Vendor
      .addCase(editVendor.fulfilled, (state, action) => {
        const index = state.vendors.findIndex(
          (v) => v.vendorId === action.payload.vendorId
        );
        state.vendors[index] = action.payload;
      })


      .addCase(removeVendor.fulfilled, (state, action) => {
        state.vendors = state.vendors.filter(
          (v) => v.vendorId !== action.payload
        );
      });
  },
});

export default vendorSlice.reducer;
